import { BurgerMenu } from "./gui/BurgerMenu";
import { GameVars } from "../../GameVars";
import { BoardManager } from "./BoardManager";

export class GUI extends Phaser.GameObjects.Container {

    private readonly burgerMenu: BurgerMenu;

    constructor(scene: Phaser.Scene, private readonly boardManager: BoardManager) {
        super(scene);

        this.burgerMenu = new BurgerMenu(scene);
        this.add(this.burgerMenu);
        this.relayout();
    }

    public relayout(): void {

        this.burgerMenu.setPosition(GameVars.gameWidth - 60, 60 * GameVars.scaleY);
        this.burgerMenu.setScale(1, GameVars.scaleY);
    }
}
